import React, { useMemo, useContext } from 'react';
import { debounce } from 'underscore';

export const SiteConfigContext = React.createContext({
  siteConfig: null,
  dispatchSiteConfig: () => { },
});

export const useSiteConfig = () => {
  const contextValue = useContext(SiteConfigContext);
  return contextValue;
};

export const useDebouncedDispatchSiteConfig = (wait = 10) => {
  const { dispatchSiteConfig } = useSiteConfig();
  const debounced = useMemo(() => debounce(dispatchSiteConfig, wait), [dispatchSiteConfig, wait]);

  return debounced;
};

export const SavedSiteConfigContext = React.createContext({
  savedSiteConfig: null,
  updateSavedSiteConfig: () => { },
});

export const useSavedSiteConfig = () => {
  const contextValue = useContext(SavedSiteConfigContext);
  return contextValue;
};
